import { LabSelectionWidget, UnitSelectionWidget, DoctorSelectionWidget } from "components/FormWidget";

const uiSchema = () => ({
  lab_ids: {
    "ui:widget": LabSelectionWidget,
  },
  unit_ids: {
    "ui:widget": UnitSelectionWidget,
  },
  doctor_ids: {
    "ui:widget": DoctorSelectionWidget,
  },
});

export default uiSchema;
